/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from 'react';
import {BreadcrumbItem,Breadcrumb} from "carbon-addons-iot-react";
import {BreadcrumbItemsHandler} from "./BreadcrumbItemsHandler";
import "./Breadcrumb.scss";

function TririgaBreadcrumb(props){
    const breadcrumbItemsHandler = new BreadcrumbItemsHandler();
    const breadcrumbItemsList = breadcrumbItemsHandler.getBreadcrumbItems(props.menuitems,props.currentSelectedMenuItemId,props.isSubPage);

         return (
            <Breadcrumb>

             {breadcrumbItemsList.map((item,index) => (
                <BreadcrumbItem 
                href={props.tririgaContextUrl+item.url} 
                title={item.label}
                key={index}
                onClick={(e) => {e.preventDefault();
                  props.breadcrumbItemClicked(item.id, e);  
                }}
                >
                {item.label}
              </BreadcrumbItem>))}
            </Breadcrumb>
         );
}


export default TririgaBreadcrumb;